// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    DispatchSetProductFilters,
    RemoveStockedItemsFilter,
    ResetPage,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";

type HandlerType = Parameters<typeof DispatchSetProductFilters>[0];

export const ExtendResetPage = (props: HandlerType) => {
    if (
        (props.parameter as any).articleTypes?.length ||
        (props.parameter as any).tag ||
        typeof props.parameter.stockedItemsOnly !== "undefined" ||
        typeof props.parameter.previouslyPurchasedProducts !== "undefined"
    ) {
        props.result.page = undefined;
    }
};

export const RemoveFilterArticleType = (props: HandlerType) => {
    (props.result as any).articleTypes = (props.result as any).articleTypes?.filter(
        (x: string) => !(props.parameter as any).articleTypes?.find((y: string) => y === x),
    );
    if ((props.result as any).articleTypes?.length === 0) {
        (props.result as any).articleTypes = undefined;
    }
};

export const RemoveFilterTag = ({ parameter: { tag }, result }: any) => {
    if (tag && tag === result.tag) {
        result.tag = undefined;
    }
};

export const AddSearchType = (props: HandlerType) => {
    const location = getLocation(props.getState());
    const parsedQuery = parseQueryString<{ searchType?: string }>(location.search);
    (props.result as any).searchType = parsedQuery?.searchType?.toLowerCase();
};

export const CustomRemoveStockedItemsFilter = (props: HandlerType) => {
    // we don't need the undefined value
    props.result.stockedItemsOnly = false;
};

addToChainAfter(chain, ResetPage, ExtendResetPage);
addToChainBefore(chain, DispatchSetProductFilters, RemoveFilterArticleType);
addToChainBefore(chain, DispatchSetProductFilters, RemoveFilterTag);
addToChainBefore(chain, DispatchSetProductFilters, AddSearchType);
replaceInChain(chain, RemoveStockedItemsFilter, CustomRemoveStockedItemsFilter);
